var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reelbuzz-menu"},[_c('div',{staticClass:"reelbuzz-content"},[_c('div',{staticClass:"reelbuzz-left"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")},on:{"click":_vm.changeIndex}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }